/* ============================================================================
   Primitivos de formulário — próprios, sem dependências externas.
   Field (label + hint) · TextInput · TextArea · Select · Switch · ColorPicker
   ============================================================================ */
import './ColorPicker.css';

/* ── Field wrapper ── */
export function Field({ label, required, hint, children, className = '' }) {
  return (
    <div className={`mg-field ${className}`}>
      {label && (
        <label className="mg-label">
          {label}{required && <span className="mg-req">*</span>}
        </label>
      )}
      {children}
      {hint && <span className="mg-hint">{hint}</span>}
    </div>
  );
}

/* ── Inputs simples (repasse de props) ── */
export const TextInput = (props) => <input className="mg-input" {...props} />;
export const TextArea = (props) => <textarea className="mg-textarea" {...props} />;
export const Select = ({ children, ...props }) => <select className="mg-select" {...props}>{children}</select>;

/* ── Switch (substitui PrimeReact InputSwitch) ── */
export function Switch({ checked, onChange, label, id }) {
  return (
    <label className="mg-switch" htmlFor={id}>
      <input
        id={id}
        type="checkbox"
        checked={!!checked}
        onChange={(e) => onChange?.(e.target.checked)}
      />
      <span className="mg-switch-track"><span className="mg-switch-thumb" /></span>
      {label && <span className="mg-switch-label">{label}</span>}
    </label>
  );
}

/* ── ColorPicker (substitui react-colorful) ──
   Swatches de marca + seletor nativo + entrada hex + preview. Zero dependências. */
const SWATCHES = [
  '#d17d34', '#a4551f', '#e2a35e', '#f0ac6c', '#b8632a',
  '#22c55e', '#0ea5e9', '#6366f1', '#a855f7', '#ec4899',
  '#ef4444', '#f59e0b', '#14b8a6', '#64748b', '#eab308',
];

function normalizeHex(value) {
  let v = (value || '').trim();
  if (v && !v.startsWith('#')) v = '#' + v;
  return v;
}

export function ColorPicker({ color, onChange }) {
  const value = normalizeHex(color) || '#d17d34';
  const isValid = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(value);

  return (
    <div className="mg-color">
      <div className="mg-color-main">
        <label className="mg-color-native" style={{ background: isValid ? value : '#d17d34' }}>
          <input type="color" value={isValid ? value : '#d17d34'} onChange={(e) => onChange(e.target.value)} />
        </label>
        <div className="mg-color-hex">
          <span>#</span>
          <input
            type="text"
            value={value.replace('#', '')}
            maxLength={6}
            onChange={(e) => onChange('#' + e.target.value.replace(/[^0-9a-fA-F]/g, ''))}
            spellCheck={false}
          />
        </div>
      </div>
      <div className="mg-color-swatches">
        {SWATCHES.map((c) => (
          <button
            key={c}
            type="button"
            className={`mg-color-swatch${value.toLowerCase() === c ? ' is-active' : ''}`}
            style={{ background: c }}
            onClick={() => onChange(c)}
            aria-label={c}
          />
        ))}
      </div>
    </div>
  );
}
